var Helper = /** @class */ (function () {
    function Helper() {
    }
    Helper.escapeRegex = function (value) {
        return value.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
    };
    /**
     * Format a list of options from a storage model for use in X-editable
     *
     * @since 1.0
     *
     * @param {Array} options List of options, can be nested (1 level max). Options have their key as the input value and their value as the input label. Parents have string 'label' and array 'options' of options.
     * @returns {Array} List of options with parents with 'text' and 'children' and options with 'id' and 'text'
     */
    Helper.formatOptionsSelect2 = function (options) {
        var foptions = [];
        if (typeof options === "undefined") {
            return foptions;
        }
        for (var i = 0; i < options.length; i++) {
            var parent_1 = void 0;
            if (typeof options[i].options !== 'undefined') {
                parent_1 = {
                    text: options[i].label,
                    children: []
                };
                for (var j in options[i].options) {
                    if (options[i].options.hasOwnProperty(j)) {
                        parent_1.children.push({
                            value: options[i].options[j].value,
                            id: options[i].options[j].value,
                            text: options[i].options[j].label
                        });
                    }
                }
            }
            else {
                parent_1 = {
                    value: options[i].value,
                    id: options[i].value,
                    text: options[i].label
                };
            }
            foptions.push(parent_1);
        }
        return foptions;
    };
    ;
    return Helper;
}());
module.exports = Helper;
